import React, { useEffect, useState } from "react";
import qs from "qs";
import { blogAxios } from "../../utils/blogAxios";
import "./styles.less";

export const CommonBlogAuthor = ({ author }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (author?.id) {
      blogAxios
        .get(
          `/articles/count?${qs.stringify({
            user: author.id,
          })}`
        )
        .then(({ data }) => setCount(data));
    }
  }, [author]);

  return (
    <div className="blog-author-info">
      <h4 className="part-title">文章作者</h4>
      <div className="author-detail">
        <div>
          <img
            style={{
              borderRadius: "50%",
              margin: "0px 18px",
            }}
            width="60px"
            height="60px"
            src={author?.photo || "https://usercontents.authing.cn/authing-avatar.png"}
            alt="avatar"
          />
          <p className="author-label">{author?.username || "--"}</p>
        </div>
        <div className="split-line"></div>
        <div>
          <p className="author-count">{count}</p>
          <p className="author-label">文章总数</p>
        </div>
      </div>
    </div>
  );
};
